<template>
  <div class="l-amap-container">
    <div class="l-amap" :id="mapId"></div>
  </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader'
var map = null
var imageLayer = null
export default {
  name: 'LAmap0',
  props: {
    mapStyle: {
      type: String,
      default: 'amap://styles/grey'
    },
    zoom: {
      type: Number,
      default: 11
    },
    center: {
      type: Array,
      default: () => [118.787975, 31.983388]
    },
    texts: {
      type: Array,
      default: null
    },
    markers: {
      type: Array,
      default: null
    },
    polylines: {
      type: Array,
      default: null
    },
    polygons: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      mapId: 'map' + parseInt(Math.random() * 1000),
      defaultSetting: {
        center: [118, 32],
        zoom: 10
      },
      mapStyleCtrlVisible: false,
      mapStyleVisible: false,
      mapStyleList: [
        { url: 'amap://styles/normal' },
        { url: 'amap://styles/macaron' },
        { url: 'amap://styles/graffiti' },
        { url: 'amap://styles/whitesmoke' },
        { url: 'amap://styles/dark' },
        { url: 'amap://styles/fresh' },
        { url: 'amap://styles/darkblue' },
        { url: 'amap://styles/blue' },
        { url: 'amap://styles/light' },
        { url: 'amap://styles/grey' }
      ]
      // textLayer: null,
      // markerLayer: null,
      // polylineLayer: null,
      // polygonLayer: null
    }
  },
  created() {
    map = null
    imageLayer = null
  },
  mounted() {
    AMapLoader.load({
      key: process.env.VUE_APP_AMAP_KEY, // 申请好的Web端开发者Key，首次调用 load 时必填
      version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      plugins: ['AMap.ControlBar', 'AMap.ToolBar', 'AMap.MouseTool', 'AMap.PolygonEditor', 'AMap.RectangleEditor'] // 插件列表
    })
      .then(AMap => {
        this.initMap()
      })
      .catch(e => {
        console.log(e)
      })
  },
  destroyed(a) {
    if (map) {
      map.destroy()
      map = null
    }
  },
  methods: {
    getMap() {
      return map
    },
    defaultMapStyle(url) {
      if (url) {
        localStorage.setItem('l_amap_mapstyle', url)
        return
      }
      var t = localStorage.getItem('l_amap_mapstyle')
      if (t) {
        return t
      } else {
        return 'amap://styles/grey'
      }
    },
    initMap() {
      var gridLayer = new AMap.TileLayer({
        zIndex: 2,
        getTileUrl: function(x, y, z) {
          return 'data:image/jpeg;base64,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'
        }
      })

      map = new AMap.Map(this.mapId, {
        center: this.defaultSetting.center,
        zoom: this.defaultSetting.zoom,
        layers: [gridLayer]
      })

      map.on('click', evt => {
        console.log(evt.pixel, evt.lnglat)
      })
    },
    resetZoomAndCenter() {
      map.setZoomAndCenter(this.defaultSetting.zoom, this.defaultSetting.center)
    },
    setImageLayer(option) {
      this.resetZoomAndCenter()
      if (imageLayer) {
        map.removeLayer(imageLayer)
        imageLayer = null
      }
      imageLayer = new AMap.ImageLayer({
        bounds: new AMap.Bounds(option.sw, option.ne),
        zooms: [8, 15],
        url: option.imgUrl, // 图片 Url
        zIndex: 2
      })
      map.addLayer(imageLayer)
    },
    getImageLayerSetting(imgWidth, imgHeight) {
      this.resetZoomAndCenter()
      var mapEl = document.getElementById(this.mapId)
      var clientWidth = mapEl.clientWidth
      var clientHeight = mapEl.clientHeight
      var h = 600
      var w = parseInt((imgWidth * h) / imgHeight)
      var pix1 = [(clientWidth - w) / 2, clientHeight - (clientHeight - h) / 2]
      var pix2 = [(clientWidth - w) / 2 + w, (clientHeight - h) / 2]
      var p1 = map.containerToLngLat(pix1)
      var p2 = map.containerToLngLat(pix2)
      return [p1, p2]
    },
    drawPolygon() {
      var editor = new AMap.PolygonEditor(map)
      editor.open()
    },
    drawPolygon2222() {
      var polygon = new AMap.Polygon({
        path: [
          [117.732208, 32.232627],
          [118.145569, 32.162901],
          [118.013733, 31.875301],
          [117.655304, 31.868304],
          [117.594879, 32.044245]
        ]
      })
      map.add(polygon)
      setTimeout(() => {
        var editor = new AMap.PolygonEditor(map, polygon)
        editor.open()
        setInterval(() => {
          console.log(
            editor
              .getTarget()
              .getPath()
              .map(a => [a.lng, a.lat])
              .join(',')
          )
          console.log(
            polygon
              .getPath()
              .map(a => [a.lng, a.lat])
              .join(',')
          )
        }, 2000)
      }, 5000)
    }
  },
  watch: {
    texts(e) {
      console.log(e)
      this.showText(e)
    },
    markers(e) {
      this.showMarker(e)
    },
    polylines(e) {
      this.showPolyline(e)
    },
    polygons(e) {
      this.showPolygon(e)
    }
  }
}
</script>
<style lang="less" scoped>
.l-amap-container {
  height: 100%;
  width: 100%;
  position: relative;
}
.l-amap {
  height: 100%;
  width: 100%;
  resize: both;
  cursor: default;
  background-color: rgb(244, 244, 244);
}
.l-amap-ctrl-layer {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  width: 30px;
  height: 30px;
  z-index: 100;
  p.icon {
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #fff center center no-repeat;
    border-radius: 4px;
    user-select: none;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
    color: grey;
    font-size: 20px;
  }
  p.icon:hover {
    background-color: rgb(200, 200, 200);
  }
  p.icon-layers {
    background-image: url('../../../image/map/layers.png');
  }
  .mapstyle {
    position: absolute;
    top: 0px;
    right: 40px;
    width: 923px;
    height: 242px;
    background: url('../../../image/map/mapstyle.jpg') center center no-repeat;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    display: flex;
    flex-wrap: wrap;
    p {
      width: 165px;
      height: 100px;
      // background-color: red;
      border-radius: 5px;
      margin: 11px 9px;
    }
  }
}

.amap-logo {
  opacity: 0;
}
.amap-copyright {
  opacity: 0;
}
</style>
